(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-finder')) {
    class GiftFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.recipient = this.dataset.defaultRecipient || '';
        this.budget = this.dataset.defaultBudget || '';
        this.recipientButtons = Array.from(this.querySelectorAll('[data-gift-recipient]'));
        this.budgetButtons = Array.from(this.querySelectorAll('[data-gift-budget]'));
        if (!this.recipientButtons.some((button) => button.dataset.giftRecipient === this.recipient)) this.recipient = '';
        if (!this.budgetButtons.some((button) => button.dataset.giftBudget === this.budget)) this.budget = '';
        this.recommendations = Array.from(this.querySelectorAll('[data-gift-recommendation]'));
        this.status = this.querySelector('[data-gift-finder-status]');
        this.panel = this.querySelector('[data-gift-finder-panel]');
        this.summary = this.querySelector('[data-gift-finder-summary]');
        this.summaryRecipient = this.querySelector('[data-gift-finder-summary-recipient]');
        this.summaryBudget = this.querySelector('[data-gift-finder-summary-budget]');
        this.resetButton = this.querySelector('[data-gift-finder-reset]');

        this.recipientButtons.forEach((button) => button.addEventListener('click', () => {
          this.recipient = this.recipient === button.dataset.giftRecipient ? '' : button.dataset.giftRecipient;
          this.update();
        }));
        this.budgetButtons.forEach((button) => button.addEventListener('click', () => {
          this.budget = this.budget === button.dataset.giftBudget ? '' : button.dataset.giftBudget;
          this.update();
        }));

        this.resetButton?.addEventListener('click', () => {
          this.recipient = '';
          this.budget = '';
          this.update();
          this.recipientButtons[0]?.focus();
        });

        this.addEventListener('shopify:block:select', (event) => {
          const recommendation = event.target.closest('[data-gift-recommendation]');
          if (recommendation) {
            this.recipient = recommendation.dataset.recipient;
            this.budget = recommendation.dataset.budget;
            this.update();
            return;
          }
          const recipientButton = event.target.closest('[data-gift-recipient]');
          if (recipientButton) {
            this.recipient = recipientButton.dataset.giftRecipient;
            this.update();
          }
        });
        this.update();
      }

      update() {
        this.recipientButtons.forEach((button) => button.setAttribute('aria-pressed', button.dataset.giftRecipient === this.recipient ? 'true' : 'false'));
        this.budgetButtons.forEach((button) => button.setAttribute('aria-pressed', button.dataset.giftBudget === this.budget ? 'true' : 'false'));

        const activeRecipientButton = this.recipientButtons.find((button) => button.dataset.giftRecipient === this.recipient);
        const activeBudgetButton = this.budgetButtons.find((button) => button.dataset.giftBudget === this.budget);
        if (this.summary) this.summary.hidden = !activeRecipientButton && !activeBudgetButton;
        if (this.summaryRecipient) {
          this.summaryRecipient.hidden = !activeRecipientButton;
          this.summaryRecipient.textContent = activeRecipientButton?.textContent.trim() || '';
        }
        if (this.summaryBudget) {
          this.summaryBudget.hidden = !activeBudgetButton;
          this.summaryBudget.textContent = activeBudgetButton?.textContent.trim() || '';
        }

        let activeRecommendation = null;
        this.recommendations.forEach((recommendation) => {
          const isActive = recommendation.dataset.recipient === this.recipient && recommendation.dataset.budget === this.budget;
          recommendation.hidden = !isActive;
          recommendation.toggleAttribute('inert', !isActive);
          if (isActive) {
            recommendation.removeAttribute('aria-hidden');
          } else {
            recommendation.setAttribute('aria-hidden', 'true');
          }
          if (isActive) activeRecommendation = recommendation;
        });

        let state = 'empty';
        let message = this.dataset.chooseBothMessage;
        if (!this.recipient && this.budget) {
          state = 'partial';
          message = this.dataset.chooseRecipientMessage;
        } else if (this.recipient && !this.budget) {
          state = 'partial';
          message = this.dataset.chooseBudgetMessage;
        } else if (activeRecommendation) {
          const hasProducts = activeRecommendation.dataset.hasProducts === 'true';
          state = hasProducts ? 'result' : 'pending';
          message = hasProducts ? this.dataset.resultMessage : this.dataset.noMatchMessage;
        } else if (this.recipient && this.budget) {
          state = 'pending';
          message = this.dataset.noMatchMessage;
        }

        if (this.panel) this.panel.dataset.state = state;
        if (this.status) this.status.textContent = message || '';

        this.dispatchEvent(new CustomEvent('gifting-hub:finder-change', {
          bubbles: true,
          detail: { recipient: this.recipient || null, budget: this.budget || null, hasResult: state === 'result' }
        }));
      }
    }
    customElements.define('gift-finder', GiftFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifting-entry-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gifting-entry-cards')) {
    class GiftingEntryCards extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.addEventListener('click', (event) => {
          const shortcut = event.target.closest('[data-gifting-entry-navigation-group]');
          if (!shortcut || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || shortcut.target || shortcut.hasAttribute('download')) return;
          const navigation = document.querySelector('gifting-navigation');
          const group = shortcut.dataset.giftingEntryNavigationGroup;
          const tab = Array.from(navigation?.querySelectorAll('[data-gifting-nav-tab]') || [])
            .find((candidate) => candidate.dataset.giftingNavTab === group);
          if (!navigation || typeof navigation.activate !== 'function' || !tab) return;
          const destinationUrl = typeof navigation.getCollectionUrl === 'function'
            ? navigation.getCollectionUrl(shortcut.href)
            : null;
          if (destinationUrl && navigation.dynamicNavigationEnabled && typeof navigation.navigateToUrl === 'function') {
            event.preventDefault();
            navigation.activate(group, false);
            navigation.navigateToUrl(destinationUrl.href, { push: true, restoreFocus: event.detail === 0 });
            return;
          }
          if (shortcut.hash !== '#GiftingNavigation') return;
          event.preventDefault();
          navigation.activate(group, false);
          navigation.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          window.requestAnimationFrame(() => tab.focus({ preventScroll: true }));
        });
      }
    }
    customElements.define('gifting-entry-cards', GiftingEntryCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifting-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gifting-navigation')) {
    class GiftingNavigation extends HTMLElement {
      connectedCallback() {
        if (this.listenerController) return;
        this.listenerController = new AbortController();
        const listenerOptions = { signal: this.listenerController.signal };
        this.dataset.initialized = 'true';
        this.dataset.enhanced = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-gifting-nav-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-gifting-nav-panel]'));
        this.status = this.querySelector('[data-gifting-navigation-status]');
        this.dynamicNavigationEnabled = this.dataset.enableDynamicNavigation === 'true' && !window.Shopify?.designMode;
        if (!this.tabs.length || !this.panels.length) return;

        const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || (this.dataset.activeGroup === 'bulk' ? null : this.tabs[0]);
        this.activate(selectedTab?.dataset.giftingNavTab || '', false);
        this.activateLandingGroup();
        window.addEventListener('hashchange', () => this.activateLandingGroup(), listenerOptions);
        this.hoverMedia = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
        this.hoverMedia.addEventListener('change', () => this.cancelHover(), listenerOptions);
        this.addEventListener('pointerdown', () => this.cancelHover(), listenerOptions);
        this.addEventListener('keydown', () => this.cancelHover(), listenerOptions);

        this.tabs.forEach((tab, index) => {
          this.bindHover(tab, tab.dataset.giftingNavTab, listenerOptions);
          tab.addEventListener('click', () => this.activate(tab.dataset.giftingNavTab, false), listenerOptions);
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;
            const nextTab = this.tabs[nextIndex];
            this.activate(nextTab.dataset.giftingNavTab, true);
          }, listenerOptions);
        });

        this.querySelectorAll('[data-gifting-bulk]').forEach((link) => {
          this.bindHover(link, '', listenerOptions);
          link.addEventListener('focus', () => {
            if (link.matches(':focus-visible')) this.activate('', false);
          }, listenerOptions);
        });

        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-gifting-nav-panel]');
          if (panel) this.activate(panel.dataset.giftingNavPanel, false);
        }, listenerOptions);

        if (this.dynamicNavigationEnabled) {
          window.__bbGiftingNavigationCache ||= new Map();
          if (!window.history.state?.giftingNavigation) {
            window.history.replaceState({ giftingNavigation: true, fetchUrl: window.location.href }, '', window.location.href);
          }
          this.addEventListener('click', (event) => this.handleDestinationClick(event), listenerOptions);
          if (!window.__bbGiftingNavigationHistoryBound) {
            window.__bbGiftingNavigationHistoryBound = true;
            window.addEventListener('popstate', (event) => {
              const navigation = document.querySelector('gifting-navigation[data-enhanced="true"]');
              const fetchUrl = event.state?.giftingNavigation ? event.state.fetchUrl : window.location.href;
              navigation?.navigateToUrl(fetchUrl, { push: false, restoreFocus: false });
            });
          }
        }
      }

      activateLandingGroup() {
        if (this.dataset.giftingHub !== 'true') return;
        const groups = {
          '#shop-by-person': ['who-its-for', 'who'],
          '#shop-by-price': ['price']
        };
        const candidates = groups[window.location.hash];
        const tab = candidates && this.tabs.find((item) => candidates.includes(item.dataset.giftingNavTab));
        if (!tab) return;
        this.activate(tab.dataset.giftingNavTab, false);
        window.requestAnimationFrame(() => {
          if (this.isConnected) this.scrollIntoView({ block: 'start', behavior: 'instant' });
        });
      }

      disconnectedCallback() {
        this.cancelHover();
        this.listenerController?.abort();
        this.listenerController = null;
      }

      bindHover(trigger, group, options) {
        trigger.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !this.hoverMedia.matches) return;
          this.cancelHover();
          this.hoverTrigger = trigger;
          this.hoverTimer = window.setTimeout(() => {
            this.hoverTimer = null;
            if (!this.isConnected || !this.hoverMedia.matches || this.hoverTrigger !== trigger) return;
            const focused = document.activeElement;
            if (this.panels.some((panel) => panel.contains(focused)) || (this.contains(focused) && focused.matches(':focus-visible'))) return;
            this.activate(group, false);
          }, 120);
        }, options);
        trigger.addEventListener('pointerleave', () => {
          if (this.hoverTrigger === trigger) this.cancelHover();
        }, options);
      }

      cancelHover() {
        window.clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
        this.hoverTrigger = null;
      }

      activate(group, focusTab) {
        this.cancelHover();
        this.tabs.forEach((tab, index) => {
          const isActive = tab.dataset.giftingNavTab === group;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive || (!group && index === 0) ? 0 : -1;
          if (isActive && focusTab) tab.focus();
        });
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.giftingNavPanel === group;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });
      }

      handleDestinationClick(event) {
        const link = event.target.closest('a.gifting-nav__destination[href], a[data-gifting-bulk][href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) return;
        const targetUrl = this.getCollectionUrl(link.href);
        if (!targetUrl) return;
        event.preventDefault();
        if (link.getAttribute('aria-current') === 'page') {
          if (link.hasAttribute('data-gifting-bulk')) this.activate('', false);
          return;
        }
        this.navigateToUrl(targetUrl.href, { push: true, restoreFocus: event.detail === 0 });
      }

      async navigateToUrl(fetchUrl, { push, restoreFocus }) {
        const targetUrl = this.getCollectionUrl(fetchUrl);
        if (!targetUrl) return;
        const requestUrl = targetUrl.href;
        this.requestController?.abort();
        const requestController = new AbortController();
        this.requestController = requestController;
        const currentMain = document.querySelector('#main-content');
        if (!currentMain) {
          window.location.assign(requestUrl);
          return;
        }
        const currentNavTop = this.getBoundingClientRect().top;
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        currentMain?.classList.add('is-gifting-navigation-loading');
        currentMain?.setAttribute('aria-busy', 'true');
        if (this.status) this.status.textContent = this.dataset.loadingMessage;
        const timeout = window.setTimeout(() => requestController.abort(), 12000);

        try {
          let html = window.__bbGiftingNavigationCache.get(requestUrl);
          if (!html) {
            const response = await fetch(requestUrl, {
              credentials: 'same-origin',
              headers: { Accept: 'text/html', 'X-Requested-With': 'GiftingNavigation' },
              signal: requestController.signal
            });
            if (!response.ok) throw new Error(`Navigation request failed with ${response.status}`);
            if (!this.getCollectionUrl(response.url)) throw new Error('Navigation response left the collection route');
            if (!response.headers.get('content-type')?.toLowerCase().includes('text/html')) throw new Error('Navigation response was not HTML');
            html = await response.text();
            this.cacheResponse(requestUrl, html);
          }

          if (requestController.signal.aborted) return;
          const nextDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextMain = nextDocument.querySelector('#main-content');
          if (!nextMain) throw new Error('Navigation response did not include main content');
          const externalScripts = Array.from(nextMain.querySelectorAll('script[src]'))
            .map((script) => this.getTrustedThemeScriptUrl(script.getAttribute('src')))
            .filter(Boolean);
          nextMain.querySelectorAll('script').forEach((script) => script.remove());
          const importedMain = document.importNode(nextMain, true);
          importedMain.classList.add('is-gifting-navigation-loading');
          importedMain.setAttribute('aria-busy', 'true');
          const canonicalCandidate = nextDocument.querySelector('link[rel="canonical"]')?.href;
          const canonicalUrl = this.getCollectionUrl(canonicalCandidate)?.href || requestUrl;

          if (push) {
            // Keep the template override in browser history so reloads retain the gifting destination layout.
            const displayUrl = new URL(requestUrl);
            window.history.pushState({ giftingNavigation: true, fetchUrl: requestUrl }, '', `${displayUrl.pathname}${displayUrl.search}${displayUrl.hash}`);
          }

          this.syncDocumentMetadata(nextDocument, canonicalUrl);
          currentMain.replaceWith(importedMain);
          void this.loadExternalScripts(externalScripts);

          await new Promise((resolve) => window.requestAnimationFrame(resolve));
          const nextNavigation = document.querySelector('gifting-navigation[data-enhanced="true"]');
          const nextMainElement = document.querySelector('#main-content');
          const nextNavTop = nextNavigation?.getBoundingClientRect().top;
          if (typeof nextNavTop === 'number') window.scrollBy(0, nextNavTop - currentNavTop);
          nextMainElement?.classList.remove('is-gifting-navigation-loading');
          nextMainElement?.removeAttribute('aria-busy');

          const heading = nextMainElement?.querySelector('h1')?.textContent.trim() || nextDocument.title;
          if (nextNavigation?.status) nextNavigation.status.textContent = `${nextNavigation.dataset.loadedMessage}: ${heading}`;
          if (restoreFocus) nextNavigation?.querySelector('.gifting-nav__destination[aria-current="page"], [data-gifting-bulk][aria-current="page"]')?.focus({ preventScroll: true });

          const eventDetail = { url: canonicalUrl, title: nextDocument.title, heading };
          window.dispatchEvent(new CustomEvent('gifting:navigated', { detail: eventDetail }));
          try {
            window.Shopify?.analytics?.publish('gifting_destination_viewed', eventDetail);
          } catch (error) {
            window.console.debug('Gifting navigation analytics event was not published.', error);
          }
        } catch (error) {
          if (requestController.signal.aborted && this.requestController !== requestController) return;
          window.location.assign(requestUrl);
        } finally {
          window.clearTimeout(timeout);
          if (this.isConnected) {
            this.classList.remove('is-loading');
            this.removeAttribute('aria-busy');
            document.querySelector('#main-content')?.classList.remove('is-gifting-navigation-loading');
            document.querySelector('#main-content')?.removeAttribute('aria-busy');
          }
        }
      }

      getCollectionUrl(value) {
        if (!value) return null;
        try {
          const url = new URL(value, window.location.origin);
          if (url.origin !== window.location.origin || /%2f|%5c/i.test(url.pathname)) return null;
          const segments = url.pathname.split('/').filter(Boolean);
          const isDefaultRoute = segments.length === 2 && segments[0] === 'collections';
          const isLocalizedRoute = segments.length === 3 && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(segments[0]) && segments[1] === 'collections';
          if ((!isDefaultRoute && !isLocalizedRoute) || !segments[segments.length - 1]) return null;
          return url;
        } catch (error) {
          return null;
        }
      }

      getTrustedThemeScriptUrl(value) {
        if (!value) return null;
        try {
          const url = new URL(value, window.location.origin);
          if (url.origin !== window.location.origin || !url.pathname.startsWith('/cdn/shop/t/')) return null;
          return url.href;
        } catch (error) {
          return null;
        }
      }

      cacheResponse(url, html) {
        const cache = window.__bbGiftingNavigationCache;
        if (!(cache instanceof Map)) return;
        if (cache.size >= 24) cache.delete(cache.keys().next().value);
        cache.set(url, html);
      }

      syncDocumentMetadata(nextDocument, canonicalUrl) {
        document.title = nextDocument.title;
        document.documentElement.lang = nextDocument.documentElement.lang || document.documentElement.lang;
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.href = canonicalUrl;
        const selectors = [
          'meta[name="description"]',
          'meta[property="og:title"]',
          'meta[property="og:description"]',
          'meta[property="og:url"]',
          'meta[name="twitter:title"]',
          'meta[name="twitter:description"]'
        ];
        selectors.forEach((selector) => {
          const current = document.head.querySelector(selector);
          const next = nextDocument.head.querySelector(selector);
          if (current && next) current.content = next.content;
        });
      }

      async loadExternalScripts(sources) {
        const loadedSources = new Set(Array.from(document.scripts).map((script) => script.src).filter(Boolean));
        for (const source of sources) {
          if (loadedSources.has(source)) continue;
          await new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = source;
            script.defer = true;
            script.referrerPolicy = 'same-origin';
            script.dataset.giftingNavigationScript = 'true';
            script.addEventListener('load', resolve, { once: true });
            script.addEventListener('error', resolve, { once: true });
            document.head.appendChild(script);
          });
          loadedSources.add(source);
        }
      }
    }
    customElements.define('gifting-navigation', GiftingNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  if (!document.documentElement.hasAttribute('data-gifting-menu-escape')) {
    document.documentElement.setAttribute('data-gifting-menu-escape', '');
    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
      const menu = event.target.closest('.template-gifting-hub .main-menu--desktop');
      const disclosure = menu?.querySelector('.main-nav > li > details.is-open');
      if (!disclosure || typeof menu.close !== 'function') return;
      menu.opener = disclosure.querySelector(':scope > summary');
      menu.close(disclosure, false);
      menu.toggleOverlay(false);
      menu.childNavOpen = false;
    });
    window.addEventListener('on:breakpoint-change', () => {
      queueMicrotask(() => {
        if (!document.body.classList.contains('template-gifting-hub')
          || !window.matchMedia('(max-width: 768.98px)').matches) return;
        document.querySelectorAll('.template-gifting-hub main-menu').forEach((menu) => {
          if (menu.mainDisclosure?.classList.contains('is-closing')
            && typeof menu.close === 'function') menu.close(menu.mainDisclosure, false);
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
